import React from 'react';

const InChair = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="254"
    height="272"
    fill="none"
    viewBox="0 0 254 272"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        fill="#FCF7EF"
        d="M252.29 155.05c-9.44 69.14-56.87 128.48-125.16 114.18C25.9 248.05 0 210.31 0 140.54S57.13 17.18 126 28.71C193.83 40.09 264.46 66 252.29 155.05z"
      />
      <path
        fill="#F9E3C2"
        d="M96.55 14.67c-5.22-.62-11.38-.81-11.38-.81h-5.4c-15.94 0-27.67 13-26.08 29l1.77 17.69c.57 5.69 8.71 13.34 21.71 13.34h28.65l-9.27-59.22zM219.22 176.08c2.51 1.54 5.84 2.8 7.38 2.8H237c3.19 0 4.61-5.57 4.61-10.25a13.664 13.664 0 00-4.56-4.91c-2.91-1.71-47.79-28.51-47.79-28.51l-19.73-12.09c-2.51-1.54-5.84-2.8-7.38-2.8h-13.58l4.37 15.07 66.28 40.69z"
      />
      <path
        fill="#F9E3C2"
        d="M99.2 262.11v-62.74l-16-8.11a25.93 25.93 0 01-13.32-16.44l-5.75-22.06-5.68-21.82-10.43-40a9.56 9.56 0 019.31-12.67h59.37L128 149.6l59.59 31.68 60.87 64.43c3.42 7-1.49 18-9.19 18H173a25.941 25.941 0 01-21.51-11.43l-21-31.21A41.137 41.137 0 00115 207.4l-1.85-.94v59.63l-13.95-3.98z"
      />
      <path
        fill="#61B4FF"
        d="M158.79 146.68l-5.59-30.79a25.007 25.007 0 003.05-8.25l.9 1.23 9.42 1.89c10.7 1.74 15.91-2.6 18.22-11l9.65-43.22c1.83-9.83-.71-13.69-6.16-14.58-5.45-.89-8.59 3.04-11.28 12.09l-8.85 37-26.72-9.45.18-1.49c1-9.83 5.39-40 5.39-49.8 0-13.19-14.52-25.22-29.08-25.22-14.56 0-28.49 12-28.49 25.22 0 14.5 5.48 37.09.57 52.73a25.889 25.889 0 00-4.06 3.4c-8.68 8.84-7.4 22.21-5.5 30.82 2.75 12.48 6.8 30.62 7.49 31.14-.05 1 12.94 10.29 24.95 18.59l2.13 7.3L145 192a9.998 9.998 0 014.07 5l19 45.8a14.27 14.27 0 0019 6.08c6.65-3.48 8.18-11.25 5.78-17.28l-20.05-48.42 14.69 8.82a13 13 0 015 5l23.18 41.71a12.658 12.658 0 0012.707 6.471 12.653 12.653 0 008.504-4.937 12.675 12.675 0 002.405-9.534 12.66 12.66 0 00-1.726-4.71l-23.82-42.87a28.209 28.209 0 00-10.54-10.73l-44.41-25.72z"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M151.62 116.82h6.64c1.54 0 4.86 1.26 7.38 2.8l19.72 12.09s44.88 26.8 47.79 28.51c2.91 1.71 7.29 4.9 2.28 4.9h-12.26c-1.54 0-4.86-1.26-7.38-2.8l-63.1-38.67"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M155.07 135.39l60.21 37.18c2.52 1.54 5.84 2.81 7.38 2.81h10.45c3.18 0 4.6-5.57 4.6-10.26M87.92 70.35h-14A11.75 11.75 0 0162.52 60l-1.77-17.68c-1.41-14.16 7.7-26 20.94-28.5 2.44-.45 6.64.13 9.12.35"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M73.23 70.35c-13 0-21.14-7.64-21.71-13.34l-1.77-17.69c-1.59-15.93 10.14-29 26.08-29h5.4s6.17.2 11.38.81M84.73 81.15h-24a7.288 7.288 0 00-7 9.17l11 39.92M71.31 156.21l1.59 6.27a26 26 0 0013.32 16.45L118 195.06a41.005 41.005 0 0115.43 13.64l21 31.2A25.924 25.924 0 00176 251.33h61.5a7.29 7.29 0 006.03-11.33l-7-10.36"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M60.22 149.26L66 171.31a25.928 25.928 0 0013.32 16.45l31.78 16.14a40.946 40.946 0 0115.43 13.63l21.05 31.2a25.943 25.943 0 0021.5 11.44h66.31c7.71 0 12.61-10.93 9.19-18M87.92 74.77H53.43a9.54 9.54 0 00-9.31 12.66l10.42 40M95.26 257.66v-61.82M109.21 203.71v56.46"
      />
      <path
        fill="#F9E3C2"
        d="M126.83 175.38L88.23 146 68.5 133.92c-2.51-1.54-5.83-2.8-7.38-2.8h-9.28a2.14 2.14 0 00-1.84 2.35c0 6.34 0 10.15 6.05 14.45l62.16 39c2.52 1.54 5.43-.88 7-.88h7c3.18 0 3.81-1.43 4.16-4.53-.04-3.02-6.99-4.58-9.54-6.13z"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M101.89 75.26s13.76 21.67 20.55 21.67c6.79 0 6.83-22.64 6.83-22.64"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M156.15 142.75L150.57 112c9.21-16.67-3.27-22.35-12.24-32a21.999 21.999 0 00-9.06-5.64c-2.81-1-6.64-2.91-6.69-6.78"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.44"
        d="M187.49 70.56l-16.64-1.94M154.51 104.94l9.43 1.89c10.7 1.73 15.9-2.6 18.21-11l9.66-43.21c1.82-9.83-.71-13.7-6.17-14.59-5.46-.89-8.59 3-11.31 12.07l-8.86 37-31.94-10.9"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M109.76 161.4l9.13-17.33M92.37 76.81a19.83 19.83 0 00-9.06 5.69c-8.69 8.85-7.4 22.22-5.51 30.83 2.75 12.48 6.81 30.62 7.49 31.14-.08 1.67 39.2 28.62 44.31 31.46 5.11 2.84 11.44 5.28 15.29-.36l-.18.23c3.85-5.64 1.46-11.86-4.67-16.19 0 0-38.37-28.2-38.69-28.42-.32-.22-.39-.46-.6-.68l-4.89-29.27"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M108.32 67.51c.77 4.13-.64 7.48-4.38 7.48h-.59a80.676 80.676 0 00-11.81 2"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M92.61 29.08v13.51c0 14.76 16.13 26.84 21.68 26.84h1c8.25 0 22.39-12.08 22.39-26.84V29.78"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M87.36 79.11c4.91-15.64-.57-38.23-.57-52.74 0-13.18 13.93-25.21 28.49-25.21 14.56 0 29.08 12 29.08 25.21 0 9.79-4.44 40-5.39 49.8M118.21 45.52a4.18 4.18 0 01-5.89 0"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M90.89 29.36a23.32 23.32 0 0015.53-9.78s10.58 13.88 33.75 9.78M111.13 13.33c3 3.56 12.34 7.58 17.28 8.18"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.82"
        d="M101.43 37.13a5.872 5.872 0 018.33 0M120.76 37.13a5.872 5.872 0 014.17-1.735 5.876 5.876 0 014.17 1.735"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M112.38 56.8c5.78 1.45 13-.86 14.45-4.33M144.74 114.21c2.92 0 5.83-2.25 5.83-2.25"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.44"
        d="M118.89 144.07c2.08-1 5.52.42 7 1.36l35.66 23a21.773 21.773 0 018.62 10.72l20.05 48.43c2.4 6 .88 13.8-5.77 17.28a14.288 14.288 0 01-19-6.08l-19-45.8a9.997 9.997 0 00-4.06-5l-7.07-4.28"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.44"
        d="M133.53 148.81c5.84-3.15 14.13-10.6 22.62-6.06l44.42 25.72a28.228 28.228 0 0110.53 10.72l23.82 42.88a12.691 12.691 0 01-4.63 17.29v0a12.7 12.7 0 01-17.29-4.64L189.82 193a13 13 0 00-5-5l-14.72-8.83"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M128.59 175.75h-6.36c-1.54 0-4.86-1.27-7.38-2.81l-67.38-41.29c-2.51-1.54-1-4.21.56-4.21h9.29c1.54 0 4.86 1.26 7.38 2.8l19.72 12.09"
      />
      <path
        stroke="#49505B"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.31"
        d="M46.13 129.78c0 6.33 0 10.14 6.06 14.44l62.15 39c2.52 1.54 5.84 2.8 7.38 2.8h10.45c3.18 0 4.25-3.92 4.6-7"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H253.67V271.38H0z" />
      </clipPath>
    </defs>
  </svg>
);

InChair.displayName = 'InChair';

export default InChair;
